export enum BlockchainEnum {
    BITCOIN = "BITCOIN",
    BITCOINCASH = "BITCOINCASH",
    LITECOIN = "LITECOIN",
    DASH = "DASH",
    ETHEREUM = "ETHEREUM",
    RIPPLE = "RIPPLE",
    TEZOS = "TEZOS",
    TRON = "TRON",
    BSC = "BSC",
    POLYGON = "POLYGON",
    AVALANCHE = "AVALANCHE",
    BASE = "BASE",
    SOLANA = "SOLANA",
}

export type BlockchainType = keyof typeof BlockchainEnum;

export interface Coin {
    id: number;
    name: string;
    symbol: string;
    blockchain: string;
    chainId: string | null; // the chain identifier (or token address) of the coin. if 'null' it means the base asset of the blockchain
    icon: string; // Base64d
    decimals?: number;
    usdRate?: number;
    isDeprecated?: boolean;
    isBannedFromTMS?: boolean;
}
